/* eslint-disable */
import React, { useContext } from "react";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import Media from "react-media";
import { useTransition, animated } from "react-spring";
import { MainContext } from "../App.js";

const header = ({ location }) => {
  const main = useContext(MainContext);
  const top = main.homepage;

  const transitions = useTransition(top, null, {
    from: { height: "38px" },
    enter: { height: "38pm" },
    leave: { height: "0px" }
  });

  return (
    <Media query="(max-width: 57em)">
      {matches =>
        matches ? (
          <Padder>
            {location.pathname === "/" ? (
              <Link to="/">
                <h1>
                  <img
                    src="https://cdn.wihatoolsus.com/flags/logo.svg"
                    alt="Wiha BitFinder"
                  />
                </h1>
              </Link>
            ) : (
              <Print>
                <Link to="/">
                  <h1>
                    <img
                      src="https://cdn.wihatoolsus.com/flags/mLogo.svg"
                      alt="Wiha BitFinder"
                      width="150px"
                    />
                  </h1>
                </Link>
              </Print>
            )}
          </Padder>
        ) : (
          <div>
            {location.pathname === "/" &&
              transitions.map(
                ({ item, key, props }) =>
                  item && (
                    <Topbar style={{ height: props.height }} key="a">
                      {localStorage.getItem("Country") === "USA" && (
                        <p key="1">
                          Wiha Tools USA - selling{" "}
                          <a href="https://www.wihatools.com/">Wiha</a> made hand
                          tools in the United States since 1985
                        </p>
                      )}
                      {localStorage.getItem("Country") === "Canada" && (
                        <p key="2">
                          Wiha Tools Canada{" "}
                          <img src="https://cdn.wihatoolsus.com/flags/ca-flag.png" />{" "}
                          selling <a href="https://www.wihatools.ca/">Wiha</a> made
                          hand tools in Canada since 2007
                        </p>
                      )}
                    </Topbar>
                  )
              )}
            <MainContext.Consumer>
              {context => (
                <InnerDiv>
                      <img src="https://cdn.wihatoolsus.com/flags/bitfinder.svg" />
                  <Link to="/" onClick={context.popularToggle}>
                    <h1>
                      <img
                        src="https://cdn.wihatoolsus.com/flags/logo.svg"
                        alt="Wiha BitFinder"
                      />
                    </h1>
                  </Link>
                </InnerDiv>
              )}
            </MainContext.Consumer>
          </div>
        )
      }
    </Media>
  );
};

export default header;

const Padder = styled.div`
  padding: 2rem 0.88rem 0;
  display: flex;
  justify-content: center;
`;
const InnerDiv = styled.div`
  margin: 0 auto;
  padding: 1rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 56rem;
  h1 {
    margin: 0;
  }
`;

const Sub = styled.h2`
  font-size: 0.8rem;
  text-align: right;
`;
const Topbar = styled(animated.div)`
  background: #555;
  color: #fff;
  font-weight: 400;
  text-align: center;
  display: block;
  p {
    margin: 0;
    padding: 0.5rem;
  }
  a {
    font-weight: 400;
    color: #fabb00;
  }
`;

const Print = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: center;
`;
